import { useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"

// options: { translationKeys?: { send: string, resend: string, resendIn: string } }
const useSendOTP = (options = {}) => {
  const { t } = useTranslation()

  const [cooldown, setCooldown] = useState(0)
  const [hasSentOnce, setHasSentOnce] = useState(false)
  const [hasSentCode, setHasSentCode] = useState(false)

  const { translationKeys } = options

  const i18nKeys = {
    send: translationKeys?.send || "client.profile.tabs.profile.send_code",
    resend: translationKeys?.resend || "client.profile.tabs.profile.resend_code",
    resendIn: translationKeys?.resendIn || "client.profile.tabs.profile.resend_in_seconds"
  }

  const sendCodeLabel = useMemo(() => {
    if (cooldown > 0) return t(i18nKeys.resendIn, { cooldown })
    return hasSentOnce ? t(i18nKeys.resend) : t(i18nKeys.send)
  }, [cooldown, hasSentOnce, t, i18nKeys.resendIn, i18nKeys.resend, i18nKeys.send])

  useEffect(() => {
    if (cooldown <= 0) return
    const id = setInterval(() => {
      setCooldown((s) => (s > 0 ? s - 1 : 0))
    }, 1000)
    return () => clearInterval(id)
  }, [cooldown])

  const markSent = (seconds = 60) => {
    setHasSentCode(true)
    setHasSentOnce(true)
    setCooldown(seconds)
  }

  const resetOTP = () => {
    setHasSentCode(false)
    setHasSentOnce(false)
    setCooldown(0)
  }

  return {
    cooldown,
    sendCodeLabel,
    setCooldown,
    hasSentOnce,
    setHasSentOnce,
    hasSentCode,
    setHasSentCode,
    markSent,
    resetOTP
  }
}

export default useSendOTP
